import { BaseFactory } from 'src/services/entity-factory/FactoryInterface';
import PhysicalPerson from 'src/entities/PhysicalPerson';
import * as moment from 'moment';
import Spouse from 'src/value-objects/Spouse';
import { ApiSectorOfInterestResponse } from 'src/services/entity-factory/factories/SectorOfInterestFactory';
import InvestorType from 'src/entities/InvestorType';
import EnumTypes from 'src/services/EnumStates/EnumTypes';

export interface ApiPhysicalPersonResponse {
  id: number;
  name: string;
  displayName: string;
  surname: string;
  nationality: string | null;
  idNumber: string | null;
  idExpirationDate: string | null;
  idFront: string | null;
  idBack: string | null;
  birthDate: string | null;
  phoneNumber: string | null;
  notificationEmail: string | null;
  email: string | null;
  address: string | null;
  houseNumber: string | null;
  zipCode: string | null;
  city: string | null;
  province: string | null;
  country: string | null;
  maritalStatus: string | null;
  maritalEconomicStatus: string | null;
  maritalPropertyRegime: string | null;
  occupationType: string | null;
  occupation: string | null;
  company: string | null;
  spouse: Spouse | null;
  profilePicture: string | null;
  facebookProfile: string | null;
  twitterProfile: string | null;
  linkedinProfile: string | null;
  about: string | null;
  investmentGoal: string | null;
  sectorsOfInterest: Array<ApiSectorOfInterestResponse> | null;
  personType: string;
  investorType: InvestorType;
  isPublicProfile: boolean | null;
  percentCompleted?: number;
}

interface ApiPhysicalPersonCreateRequest {
}

export class PhysicalPersonFactory extends BaseFactory<PhysicalPerson> {
  public toEntity(args: ApiPhysicalPersonResponse): PhysicalPerson {
    return new PhysicalPerson({
      id: args.id,
      name: args.name,
      displayName: args.displayName,
      surname: args.surname,
      nationality: args.nationality || undefined,
      idNumber: args.idNumber || undefined,
      idExpirationDate: args.idExpirationDate ? moment.utc(args.idExpirationDate) : undefined,
      idFront: args.idFront || undefined,
      idBack: args.idBack || undefined,
      birthDate: args.birthDate ? moment.utc(args.birthDate) : undefined,
      phoneNumber: args.phoneNumber || undefined,
      notificationEmail: args.notificationEmail || undefined,
      email: args.email || undefined,
      address: args.address || undefined,
      houseNumber: args.houseNumber || undefined,
      zipCode: args.zipCode || undefined,
      city: args.city || undefined,
      province: args.province || undefined,
      country: args.country || undefined,
      maritalStatus: EnumTypes.getMaritalStatusName(args.maritalStatus!) || undefined,
      maritalEconomicStatus: EnumTypes.getMaritalEconomicStatusName(args.maritalEconomicStatus!) || undefined,
      maritalPropertyRegime: EnumTypes.getMaritalPropertyRegimeName(args.maritalPropertyRegime!) || undefined,
      occupationType: EnumTypes.getOccupationTypesName(args.occupationType!) || undefined,
      occupation: args.occupation || undefined,
      company: args.company || undefined,
      spouse: args.spouse ? new Spouse(args.spouse) : undefined,
      profilePicture: args.profilePicture || undefined,
      facebookProfile: args.facebookProfile || undefined,
      twitterProfile: args.twitterProfile || undefined,
      linkedinProfile: args.linkedinProfile || undefined,
      about: args.about || undefined,
      investmentGoal: args.investmentGoal || undefined,
      sectorsOfInterest: args.sectorsOfInterest ?
        args.sectorsOfInterest.map(
          (sector) => this.entityFactoryFactory.sectorOfInterestFactory.toEntity(sector)
        ) :
        [],
      personType: args.personType,
      investorType: new InvestorType({...args.investorType,
        type: EnumTypes.getInvestorTypeName(args.investorType.type)}),
      isPublicProfile: args.isPublicProfile || false,
      percentCompleted: args.percentCompleted || 0,
    });
  }

  public toRequest(physicalPerson: PhysicalPerson): ApiPhysicalPersonCreateRequest {
    const maritalStatus = EnumTypes.returnMaritalStatusName(physicalPerson.maritalStatus);
    const maritalEconomicStatus =
      EnumTypes.returnMaritalEconomicStatusName(physicalPerson.maritalEconomicStatus);
    const maritalPropertyRegime =
      EnumTypes.returnMaritalPropertyRegimeName(physicalPerson.maritalPropertyRegime);
    const occupationType = EnumTypes.returnOccupationTypesName(physicalPerson.occupationType);

    return ({
      ...physicalPerson,
      maritalStatus: maritalStatus,
      maritalEconomicStatus: maritalEconomicStatus,
      maritalPropertyRegime: maritalPropertyRegime,
      occupationType: occupationType,
    });
  }
}



// WEBPACK FOOTER //
// ./src/services/entity-factory/factories/PhysicalPersonFactory.tsx